import { render, staticRenderFns } from "./CallModal.vue?vue&type=template&id=48ec14f8&"
import script from "./CallModal.vue?vue&type=script&lang=js&"
export * from "./CallModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports